/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'user-face-dissatisfied': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M10 1.25a8.75 8.75 0 100 17.5 8.75 8.75 0 000-17.5zm0 16.25a7.5 7.5 0 110-15 7.5 7.5 0 010 15zM7.187 6.875a1.563 1.563 0 100 3.125 1.563 1.563 0 000-3.125zm5.625 0a1.563 1.563 0 100 3.125 1.563 1.563 0 000-3.125zm-2.812 5a5 5 0 00-4.281 2.431l1.068.625a3.75 3.75 0 016.426 0l1.068-.625A5 5 0 0010 11.875z"/>'
  }
})
